const VEHICLE_TYPE = {
  carSmall: {
    id: 'CAR_SMALL',
    capacity: 6,
    translationString: 'admin.vehicle.types.CAR_SMALL',
  },
  carRegular: {
    id: 'CAR_REGULAR',
    capacity: 10,
    translationString: 'admin.vehicle.types.CAR_REGULAR',
  },
  panelVan: {
    id: 'PANEL_VAN',
    capacity: 20,
    translationString: 'admin.vehicle.types.PANEL_VAN',
  },
  van: {
    id: 'VAN',
    capacity: 40,
    translationString: 'admin.vehicle.types.VAN',
  },
  truckSmall: {
    id: 'TRUCK_SMALL',
    capacity: 60,
    translationString: 'admin.vehicle.types.TRUCK_SMALL',
  },
  truckLarge: {
    id: 'TRUCK_LARGE',
    capacity: 100,
    translationString: 'admin.vehicle.types.TRUCK_LARGE',
  },
};

export default VEHICLE_TYPE;
